/**
 * Safely registers a custom element with validation and logging
 */
export function safeDefineCustomElement(tagName: string, elConstructor: any, componentName?: string): void {
  if (customElements.get(tagName)) {
    console.warn(`Custom element '${tagName}' is already registered. Skipping registration.`);
    return; // Already registered, skip silently
  }

  try {
    customElements.define(tagName, elConstructor);
    console.log(`Successfully registered custom element '${tagName}'`);
  } catch (error) {
    if (error instanceof DOMException && error.name === 'NotSupportedError') {
      console.warn(
        `Custom element '${tagName}' was already registered by another module. This is expected in micro-frontend environments.`,
      );
    } else {
      console.error(`Failed to register custom element '${tagName}':`, error);
    }
  }
}
